import type { RoleDTO } from '../api/types';
import { CLSType, type CLSFilters, type Role } from '../model/types';

const mapClsFilters = (
  dto: NonNullable<NonNullable<RoleDTO['rules']>['clsFilters']>,
): CLSFilters => ({
  type: dto.type === 'blacklist' ? CLSType.BLACKLIST : CLSType.WHITELIST,
  columns: dto.columns,
});

export const mapRole = (dto: RoleDTO): Role => ({
  id: dto.id,
  name: dto.name,
  description: dto.description,
  organizationId: dto.organizationId,
  rules: dto.rules
    ? {
        capabilities: dto.rules.capabilities,
        viewsRestrictions: dto.rules.viewsRestrictions,
        rlsFilters: dto.rules.rlsFilters,
        clsFilters: dto.rules.clsFilters
          ? mapClsFilters(dto.rules.clsFilters)
          : undefined,
      }
    : {},
});
